// Deduplicate concurrent identical reads; only the latest request may update the view.
export function createLatestLoader(update) {
  let version = 0;
  let pending = null;
  return {
    load(key, fetcher) {
      if (pending?.key === key) return pending.promise;
      const current = ++version;
      update({ loading: true, error: null });
      const promise = Promise.resolve().then(fetcher).then(
        data => { if (current === version) update({ data }); return data; },
        error => { if (current === version) update({ error }); return undefined; }
      ).finally(() => {
        if (current === version) { pending = null; update({ loading: false }); }
      });
      pending = { key, promise };
      return promise;
    },
    invalidate() { version++; pending = null; },
  };
}

// Editors own their write, and publish the returned device only after success.
export async function saveDeviceSection(save, id, fields) {
  const response = await save(id, fields);
  if (!response?.success || !response.data?._id) throw new Error('Invalid device response');
  return response.data;
}
